import apiConfig from "../api-config";
const api_base_url = apiConfig.socket_base_url;
const url = `${api_base_url}/main/notify`;
const d_id = sessionStorage.getItem("d_id");

export const wsNotify = () => {
  const ws = new WebSocket(`${url}?d_id=${d_id}`);

  // ws.onopen = () => {
  //   console.log("WebSocket connection opened");
  //   ws.send(JSON.stringify({ message: "Hello from client!" }));
  // };

  ws.onmessage = (event) => {
    console.log("WebSocket message received:", event.data);
  };

  ws.onclose = () => {
    console.log("WebSocket connection closed");
  };

  ws.onerror = (err) => {
    console.error("WebSocket error:", err);
  };

  return ws;
};